import { render, staticRenderFns } from "./OpenScreen.vue?vue&type=template&id=1283da0c&"
import script from "./OpenScreen.vue?vue&type=script&lang=js&"
export * from "./OpenScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports